import EnvironmentService from "./environmentService";
import { ICompanyMatchRequest } from "../interfaces/ICompanyMatchRequest";
import HttpClient from "./httpClient";
import { Observable } from "rxjs";
import { ApiEndpointResolver } from "./apiEndpointResolver";

const DNB_ALREADY_CALLED_KEY = "wbm_dnb_already_called";

export const DnBService = {
  shouldCallAPI(
    isNonUser: boolean,
    enableDnBCall: boolean,
    state: string,
    visitId: string,
    countryCode: string,
  ): void {
    if (
      !isNonUser ||
      !enableDnBCall ||
      !state ||
      (countryCode && countryCode.toUpperCase() !== "US") ||
      sessionStorage.getItem(DNB_ALREADY_CALLED_KEY) === "true"
    ) {
      return;
    }

    const { ecomInFootprintStates, ecomDnBUrl } = EnvironmentService.get();
    if (!ecomInFootprintStates?.split(",").includes(state)) {
      return;
    }

    sessionStorage.setItem(DNB_ALREADY_CALLED_KEY, "true");
    this.callAPI(ecomDnBUrl, visitId);
  },

  async callAPI(dnbUrl: string, visitId: string): Promise<void> {
    const response = await fetch(dnbUrl, { credentials: "include" });

    if (!response.ok) {
      throw new Error(`HTTP error status: ${response.status}`);
    }

    const data: ICompanyMatchRequest = await response.json();
    const updatedData = {
      ...data,
      visitId: visitId,
      url: window.location.href,
    };

    if (updatedData?.duns) {
      this.savePropsForClient(updatedData);

      if (!visitId) {
        throw new Error(
          `Unable to write DnB API Response to AX Table due to missing visitId on: ${window.location.href}`,
        );
      }

      this.saveCompanyMatchResponse(updatedData).subscribe();
    }
  },

  savePropsForClient(data: ICompanyMatchRequest): void {
    const { ecomDnBPropList } = EnvironmentService.get();
    const fields: (keyof ICompanyMatchRequest)[] = ecomDnBPropList.split(
      ",",
    ) as (keyof ICompanyMatchRequest)[];

    fields.forEach((field) =>
      localStorage.setItem(`dnb.${field}`, data[field] || ""),
    );
  },
  saveCompanyMatchResponse(data: ICompanyMatchRequest): Observable<boolean> {
    return HttpClient.post<boolean>(
      {
        baseUri: ApiEndpointResolver.getLogCompanyMatchUrl(),
        body: data,
      },
      {
        withCredentials: true,
      },
    );
  },
};
